import {
  getStorageItem,
  removeStorageItem,
  setStorageItem,
} from 'app/adapters/storage';
import {
  ACCOUNT_THEME_IDS,
  AccountThemeId,
  DEFAULT_ACCOUNT_THEME,
  isAccountThemeId,
  normalizeAccountThemeId,
} from 'app/constants/accountThemes';
import { AccountProperty } from 'app/services/api/models/AccountProperty';
import { getThemeColor } from 'app/utils/account-properties';

export const ACCOUNT_THEME_STORAGE_KEY = 'COLOR_THEME';

export function getStoredAccountTheme(): AccountThemeId | null {
  try {
    const stored = getStorageItem(ACCOUNT_THEME_STORAGE_KEY);

    if (typeof stored === 'string' && isAccountThemeId(stored)) {
      return stored;
    }
  } catch {
    // localStorage may be unavailable in some environments.
  }

  return null;
}

export function getBootstrapAccountTheme(): AccountThemeId {
  return getStoredAccountTheme() ?? DEFAULT_ACCOUNT_THEME;
}

export function clearStoredAccountTheme() {
  try {
    removeStorageItem(ACCOUNT_THEME_STORAGE_KEY);
  } catch {
    // localStorage may be unavailable in some environments.
  }
}

type ApplyAccountThemeOptions = {
  persist?: boolean;
};

export function applyAccountTheme(
  themeId: string,
  options: ApplyAccountThemeOptions = {},
) {
  const { persist = true } = options;
  const theme = normalizeAccountThemeId(themeId);
  const { body } = document;

  ACCOUNT_THEME_IDS.forEach(id => {
    body.classList.remove(id);
  });

  body.classList.add(theme);
  body.dataset.accountTheme = theme;

  if (!persist) {
    return;
  }

  try {
    setStorageItem(ACCOUNT_THEME_STORAGE_KEY, theme);
  } catch {
    // localStorage may be unavailable in some environments.
  }
}

export function getAccountThemeFromProperties(
  accountProperties: AccountProperty[],
) {
  return normalizeAccountThemeId(getThemeColor(accountProperties));
}
